import React from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '../lib/apolloClient';
import SucceedoIntegrations from '../components/Succeedo/Integrations/SucceedoIntegrations';

// Rails server renders the initial connection state as props.
// The component handles all subsequent API interactions directly.
const SucceedoIntegrationsContainer = (props, _railsContext) => (
  <ApolloProvider client={client}>
    <SucceedoIntegrations {...props} />
  </ApolloProvider>
);

export default SucceedoIntegrationsContainer;
